import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_FILELISTER_REGISTRY_KEY, META_TYPE, META_VER } from './fileListerCommandRegisteryType';

/**
 * Registers the /files command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /files — opens the FileListerWidget card.
 */
export function registerFileListerCommand() {
    commandEngine.register('/files', {
        hint: 'Open file lister',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_FILELISTER_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
